<template>
  <div
    class="tprogressbar"
    :style="`
      height: ${height};
      width: ${width};
    `"
    >
    <div class="tprogressbar-value">{{computed_value}}%</div>
    <div
      class="tprogressbar-progress blue"
      :style="`width: ${computed_value}%`"
    >
    </div>
  </div>
</template>
<script>
  export default {
    props: ['height', 'width', 'value', 'ifc_size'],
    data: () => ({
      computed_size: 0,
      interval: ''
    }),
    computed: {
      computed_value: function() {
        if (this.value) {
          return this.value;
        } else {
          return Math.min(parseInt((this.computed_size / this.ifc_size) * 100), 99);
        }
      }
    },
    created() {
      if (this.ifc_size) {
        let self = this;
        this.interval = setInterval(self.compute_size, 1000)
      }
    },
    methods: {
      compute_size() {
        if (Math.floor(Math.random() * 2) == 0) {
          this.computed_size = this.computed_size + 0.14;
        }
      }
    }
  }
</script>
<style>
  .tprogressbar {
    position: relative;
    border: solid 1px white;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

  }
  .tprogressbar-progress {
    position: absolute;
    display: flex;
    height: 100%;
    top: 0px;
    left: 0px;
    border-radius: 5px;
  }
  .tprogressbar-value {
    z-index: 10;
  }
</style>
